export default __webpack_public_path__ + "static/media/SaveTheDatePhoto.112cc24e.png";